export enum MovinmotionAppEnum {
  ADMIN = 'ADMIN',
  WORKER = 'WORKER',
  TALENTS = 'TALENTS',
  TALENT_BO = 'TALENT_BO',
  COMPTA = 'COMPTA',
  SOCIAL = 'SOCIAL',
  CORE = 'CORE',
  EMPLOYEUR = 'EMPLOYEUR',
  NDA = 'NDA',
}
